import { useRef } from 'react'
import { useParams } from 'react-router-dom';
import Availability from '../../components/userAvailability/Availability';
import { Toast } from 'primereact/toast';
import FlexComponent from '../../components/FlexComponent';

const AppointmentAvailability = () => {
  const {userId} = useParams();
  const toast = useRef(null);


  return (
    <>
      <Toast ref={toast} />
      <div style={{ padding: "2.5rem 0", background: "white", position: 'relative' }}>
        <FlexComponent justifyContent="center" style={{minHeight: "80vh"}} alignItems="start" >
          <Availability userId={userId} toast={toast} availabilityType="Appointment" headingTitle="Appointment"/>
        </FlexComponent>
      </div>
    </>
  );
}
export default AppointmentAvailability;